import { setSessionCookies, getSessionCookies } from 'portal-utils/session-cookies'
import { RP_PRIVACY_SETTINGS } from 'portal-modules/common/constants/keys'
// action types
const UPDATE_COOKIES_NOTICE_STATUS =
  'rp/permission/UPDATE_COOKIES_NOTICE_STATUS'

// reducer – safe default so privacyItems.groups is never read from undefined
const privacyItems =
  typeof window !== 'undefined' && window.rpSettings?.groups
    ? { groups: window.rpSettings.groups, is_eu: window.rpSettings.is_eu }
    : { groups: {}, is_eu: false }

const persistedCookies = getSessionCookies(RP_PRIVACY_SETTINGS)

export default (
  state = {
    isCookiesAccepted: persistedCookies?.isCookiesAccepted || false,
    enabled_all: persistedCookies?.enabled_all ?? true,
    ...privacyItems,
  },
  { payload, type },
) => {
  switch (type) {
    case UPDATE_COOKIES_NOTICE_STATUS:
      return { ...state, ...payload }
    default:
      return state
  }
}

// action creators
// payload = boolean
export const updateCookiesNoticeStatus = (payload, actionType) => {
  if (actionType === 'specific')
    return {
      type: UPDATE_COOKIES_NOTICE_STATUS,
      payload: {
        groups: payload,
        isCookiesAccepted: true,
      },
    }
  if (!privacyItems?.groups) {
    return {
      type: UPDATE_COOKIES_NOTICE_STATUS,
      payload: { isCookiesAccepted: true },
    }
  }
  const updatedGroupItem = Object.values(privacyItems.groups).map(group => ({
    ...group,
    group_items: { ...group.group_items },
  }))
  updatedGroupItem.forEach(({ group_items, group_id }, index) => {
    if (!group_items) return
    Object.values(group_items).forEach(items => {
      updatedGroupItem[index].group_items[items?.group_item_id] = {
        ...items,
        checked: actionType === 'accept_all' || parseInt(group_id, 10) === 1,
      }
    })
  })
  return {
    type: UPDATE_COOKIES_NOTICE_STATUS,
    payload: {
      groups: updatedGroupItem,
      isCookiesAccepted: true,
    },
  }
}

export const requestCookiesUpdate = () => {
  let cookiesData = (getSessionCookies(RP_PRIVACY_SETTINGS)) || {
    enabled_all: privacyItems?.is_eu ? false : true,
    isCookiesAccepted: false,
  }
  setSessionCookies(RP_PRIVACY_SETTINGS, cookiesData, true)

  const updatedGroupItem = privacyItems?.groups
    ? Object.values(privacyItems.groups).map(group => ({
        ...group,
        group_items: { ...group.group_items },
      }))
    : undefined
  if (updatedGroupItem) {
    updatedGroupItem.forEach(({ group_items, group_id }, index) => {
      if (!group_items) return
      Object.values(group_items).forEach(items => {
        updatedGroupItem[index].group_items[items?.group_item_id] = {
          ...items,
          checked:
            parseInt(group_id, 10) === 1 ||
            cookiesData?.enabled_all === true ||
            (Array.isArray(cookiesData?.groups) &&
              !cookiesData.groups.includes(items?.group_item_name)),
        }
      })
    })
  }

  return {
    type: UPDATE_COOKIES_NOTICE_STATUS,
    payload: {
      groups: updatedGroupItem,
      isCookiesAccepted: cookiesData?.isCookiesAccepted,
    },
  }
}

export const requestCookieBannerClose = () => {
  return {
    type: UPDATE_COOKIES_NOTICE_STATUS,
    payload: {
      isCookiesAccepted: true,
    },
  }
}
